import React from 'react';
import AnnouncementBar from '../components/AnnouncementBar';
import Header from '../components/Header';
import HeroBanner from '../components/HeroBanner';
import BestSellingSpices from '../components/BestSellingSpices';
import FeaturedSpice from '../components/FeaturedSpice';
import TrendingRecipes from '../components/TrendingRecipes';
import Articles from '../components/Articles';
import Footer from '../components/Footer';

export default function Home() {
  return (
    <>
      <AnnouncementBar />
      <Header />
      <main>
        <HeroBanner />
        <BestSellingSpices />
        <FeaturedSpice />
        <TrendingRecipes />
        <Articles />
      </main>
      <Footer />
    </>
  );
}
